import { AccumServiceType, AccumulatorVariant, EnrichedAccumItemType } from 'types/accumulators';

import { BaseTariff } from './TextContent/byTariff/BaseTariff';
import { ProstoySvayzZTariff } from './TextContent/byTariff/ProstoySvayzZTariff';

export const getAccumulatorTextContent = (
  accumulatorVariant: AccumulatorVariant,
): React.FC<{
  accumulator: EnrichedAccumItemType;
  isInline?: boolean;
  isMobile?: boolean;
  mainCtn?: string;
  onMetricView?: (data: string) => void;
  services?: AccumServiceType;
  tetheringIsLow?: boolean;
  userType: string;
}> => {
  if (accumulatorVariant === 'base') {
    return BaseTariff;
  }

  return ProstoySvayzZTariff;
};

export const getAccumulatorVariant = ({
  isProstoy,
  isSvyazZ,
}: {
  isProstoy: boolean;
  isSvyazZ: boolean;
}): AccumulatorVariant => {
  if (isProstoy) {
    return 'prostoy';
  }

  if (isSvyazZ) {
    return 'svyazZ';
  }

  return 'base';
};
